module.exports = __webpack_public_path__ + "img/load-more-icon.3953a073.svg";